class DynamicSwiper {
  constructor(selector = '.swiper-section', breakpoint = 768) {
    this.selector = selector;
    this.breakpoint = breakpoint;
    this.swiperSections = document.querySelectorAll(this.selector);
    this.swiperInstances = new Map();

    if (this.swiperSections.length > 0) {
      this.initSwipers();
      this.addResizeListener();
    }
  }

  initSwipers() {
    this.swiperSections.forEach((section) => this.initSwiper(section));
  }

  initSwiper(section) {
    const swiperId = section.id;
    const swiperEl = section.querySelector('.swiper');
    if (!swiperEl) return;

    if (this.swiperInstances.has(swiperId)) {
      this.swiperInstances.get(swiperId).destroy(true, true);
    }

    const slidesCountMobile = parseFloat(section.dataset.slidesCountMobile) || 1;
    const slidesCountDesktop = parseFloat(section.dataset.slidesCountDesktop) || 2;
    const spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile) || 10;
    const spaceBetweenDesktop = parseInt(section.dataset.spaceBetweenDesktop) || 16;
    const effectMobile = section.dataset.effectMobile || 'slide';
    const effectDesktop = section.dataset.effectDesktop || 'material';
    const autoplay = section.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 3000;
    const centeredSlidesMobile = section.dataset.centerSlidesMobile === 'true';
    const centeredSlidesDesktop = section.dataset.centerSlidesDesktop === 'true';

    const isMobile = window.innerWidth <= this.breakpoint;
    const params = {
      modules: [EffectMaterial],
      slidesPerView: isMobile ? slidesCountMobile : slidesCountDesktop,
      spaceBetween: isMobile ? spaceBetweenMobile : spaceBetweenDesktop,
      effect: isMobile ? effectMobile : effectDesktop,
      centeredSlides: isMobile ? centeredSlidesMobile : centeredSlidesDesktop,
      grabCursor: true,
      autoplay: autoplay
        ? { delay: autoplayDelay, disableOnInteraction: false }
        : false,
      autoHeight: true,
      slideToClickedSlide: false,
      loop: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        enabled: true,
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      watchSlidesProgress: true,
      slidesPerGroupAuto: false,
    };

    const instance = new Swiper(`#${swiperId} .swiper`, params);
    this.swiperInstances.set(swiperId, instance);
  }

  addResizeListener() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.initSwipers(), 200);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DynamicSwiper();
});
